var moduleMap = {
	"./diContainer": () => {
		return Promise.all(/* diContainer */[__webpack_require__.e("vendors-node_modules_estee_elc-formatters_src_business-unit-id-parser_BusinessUnitIdParser_ts-e11395"), __webpack_require__.e("diContainer")]).then(() => (() => ((__webpack_require__("./src/service-setup/diContainer.ts")))));
	},
	"./buy-online-pickup-in-store-modal": () => {
		return Promise.all(/* buy-online-pickup-in-store-modal */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("buy-online-pickup-in-store-modal")]).then(() => (() => ((__webpack_require__("./src/exported/buy-online-pickup-in-store-modal/index.ts")))));
	},
	"./find-in-store-button": () => {
		return Promise.all(/* find-in-store-button */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("find-in-store-button")]).then(() => (() => ((__webpack_require__("./src/exported/find-in-store-button/index.ts")))));
	},
	"./find-in-store-modal": () => {
		return Promise.all(/* find-in-store-modal */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("find-in-store-modal")]).then(() => (() => ((__webpack_require__("./src/exported/find-in-store-modal/index.ts")))));
	},
	"./pick-up-in-store": () => {
		return Promise.all(/* pick-up-in-store */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("pick-up-in-store")]).then(() => (() => ((__webpack_require__("./src/exported/pickup-in-store/index.ts")))));
	},
	"./store-details": () => {
		return Promise.all(/* store-details */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("store-details")]).then(() => (() => ((__webpack_require__("./src/exported/store-details/index.ts")))));
	},
	"./stores": () => {
		return Promise.all(/* stores */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("stores")]).then(() => (() => ((__webpack_require__("./src/exported/stores/index.ts")))));
	},
	"./stores-directory": () => {
		return Promise.all(/* stores-directory */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("stores-directory")]).then(() => (() => ((__webpack_require__("./src/exported/stores-directory/index.ts")))));
	},
	"./store-notification": () => {
		return Promise.all(/* store-notification */[__webpack_require__.e("vendors-node_modules_estee_elc-service_src_Service_ServiceManager_BaseComponent_tsx"), __webpack_require__.e("store-notification")]).then(() => (() => ((__webpack_require__("./src/exported/store-notification/index.ts")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});